<span class="flex justify-center items-center text-(--p-primary-color) h-full">
    @if(value()) {
        <span class="material-symbols-outlined">check</span>
    }
</span>
